/**
 * :: USAGE ::
 *
 * "subPath" is NOT expected to use on component level since it is not a full path
 * "path" is expected to use for page navigation on component level if there is no additional param to resolve
 * "pathResolver" is expected to use when the url needs to combine with some additional params
 * "canonicalPathResolver" is expected for SEO indexed page only
 * "alternatePaths" is expected to use as possible alternate path options for the page
 *
 */

export const baseUrl: { [key: string]: string } = {
  hotel: '/hotel',
  plan: '/plan',
};

const paths = {
  top: {
    path: '/',
    pathResolver: () => `/`,
    canonicalPathResolver: () => `/`,
  },

  domesticProvider: {
    path: `${baseUrl.hotel}/domestic`,
  },

  domesticPlan: {
    path: `${baseUrl.plan}/domestic`,
  },

  overseasProvider: {
    path: `${baseUrl.hotel}/overseas`,
  },

  overseasPlan: {
    path: `${baseUrl.plan}/overseas`,
  },
};

export default paths;
